import { DashboardActionTypes } from "../models/dashboardActions";
import { DECREASE_PACK_TOTAL_PLAN } from "../types";

export default (_id: string): DashboardActionTypes => ({
    type: DECREASE_PACK_TOTAL_PLAN,
    payload: _id,
});